import { useSelector } from '../actions/types';
import { ArticlePageQuery } from '@elevio-kb/queries/dist/types';
import * as selectors from '../selectors';
import { Maybe } from '../utils/types';

type Result = {
  fetchingStatus: selectors.FetchingStatus;
  data: Maybe<ArticlePageQuery>;
};

export default function useArticlePageData(articleId: string): Result {
  const fetchingStatus = useSelector((state) =>
    selectors.articlePageFetchingStatus(state, articleId)
  );

  const data = useSelector((state) =>
    selectors.getArticlePageData(state, articleId)
  );

  return {
    fetchingStatus,
    data,
  };
}
